import { Dialog as BaseDialog } from "@base-ui-components/react/dialog";
import {
  dialogActionsClasses,
  dialogBackdropClasses,
  dialogCloseButtonClasses,
  dialogDescriptionClasses,
  dialogPopupClasses,
  // dialogTitleClasses,
  DialogVariants,
} from "./Dialog.style";
import React, { ComponentProps } from "react";
import Typography from "@/Typography";
import { XIcon } from "lucide-react";

type DialogProps = DialogVariants &
  ComponentProps<typeof BaseDialog.Root> & {
    className?: string;
    children?: React.ReactNode;
    title?: string;
    triggerRender?: BaseDialog.Trigger.Props["render"];
    triggerText?: string;
    scrollable?: boolean;
  };

const Dialog = (props: DialogProps) => {
  const {
    className,
    children,
    maxWidth,
    title,
    open,
    onOpenChange,
    triggerRender = <button />,
    triggerText = "View notifications",
    scrollable,
    ...others
  } = props;

  return (
    <BaseDialog.Root open={open} onOpenChange={onOpenChange} {...others}>
      {typeof open === "undefined" && (
        <BaseDialog.Trigger
          render={(props) =>
            triggerRender ? (
              React.isValidElement(triggerRender) ? (
                React.cloneElement(triggerRender, props)
              ) : typeof triggerRender === "function" ? (
                triggerRender(props, { disabled: false, open: false })
              ) : (
                <button />
              )
            ) : (
              <button />
            )
          }
        >
          {triggerText}
        </BaseDialog.Trigger>
      )}

      <BaseDialog.Portal>
        <BaseDialog.Backdrop className={dialogBackdropClasses({})} />
        <BaseDialog.Popup
          className={dialogPopupClasses({
            class: className,
            maxWidth,
            disableGutters: scrollable,
          })}
        >
          {/* Header */}
          {title && (
            <div className="flex justify-between items-center">
              <BaseDialog.Title
                render={<Typography variant="h3">{title}</Typography>}
              />
            </div>
          )}

          {/* Content */}
          <BaseDialog.Description
            render={<div />}
            className={dialogDescriptionClasses({
              scrollabel: scrollable,
              class:
                "max-h-[calc(100vh-200px)] overflow-y-auto scroll-smooth  [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]",
            })}
          >
            {children}
          </BaseDialog.Description>
          {/* Actions */}
          <div className={dialogActionsClasses()}>
            <BaseDialog.Close className={dialogCloseButtonClasses()}>
              <XIcon />
            </BaseDialog.Close>
          </div>
        </BaseDialog.Popup>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  );
};

export default Dialog;
